var AlligatorView, Backbone, SharedUtilHelper, SupportProblemSolvedTemplate, SupportProblemSolvedView, SupportProgressBarView, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportProgressBarView = require('./progress_bar_view');

AlligatorView = require('../../../shared/frontend/views/alligator_view');

SharedUtilHelper = require('../../../shared/frontend/helpers/utils');

SupportUtilsHelper = require('../helpers/utils');

Backbone = require('backbone');

Backbone.$ = $;

SupportProblemSolvedTemplate = require('../../problem_solved.html.mustache');

SupportProblemSolvedView = (function(superClass) {
  extend(SupportProblemSolvedView, superClass);

  function SupportProblemSolvedView() {
    return SupportProblemSolvedView.__super__.constructor.apply(this, arguments);
  }

  SupportProblemSolvedView.prototype.className = 'problem-solved';

  SupportProblemSolvedView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.template = SupportProblemSolvedTemplate;
    return this.id = 'problem-solved';
  };

  SupportProblemSolvedView.prototype.events = {
    'click .contact-us-from-problem-solved': 'renderStepThree',
    'click #needHelpAgain': 'renderStepTwo'
  };

  SupportProblemSolvedView.prototype.render = function() {
    this.$el.append(toHtml(this.template, this.toHash(this.options), this.I18nScope));
    this.hideComponents();
    return this.showComponents();
  };

  SupportProblemSolvedView.prototype.renderStepThree = function() {
    return propagateEventBeforeReplacingElements(function() {
      return Backbone.history.navigate('#contact-us', {
        trigger: true
      });
    });
  };

  SupportProblemSolvedView.prototype.renderStepTwo = function() {
    $('.step-container', '#v2_other').empty();
    $('.vertical-container').show();
    AlligatorView.hideWidgets();
    return propagateEventBeforeReplacingElements(function() {
      return Backbone.history.navigate('#select-issue', {
        trigger: false
      });
    });
  };

  SupportProblemSolvedView.prototype.toHash = function(options) {
    if (options == null) {
      options = {};
    }
    return options;
  };

  SupportProblemSolvedView.prototype.hideComponents = function() {
    return SupportUtilsHelper.hideFloatingBoldChat();
  };

  SupportProblemSolvedView.prototype.showComponents = function() {
    return AlligatorView.showWidgets('problem-solved');
  };

  SupportProblemSolvedView.prototype.close = function() {};

  return SupportProblemSolvedView;

})(Backbone.View);

module.exports = SupportProblemSolvedView;

//# sourceMappingURL=data:application/json;base64,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
